export const searchTermIndentifier = 'searchTerm';
export const parentCategoryIdentifier = 'parentCategory';
export const secondLevelCategoryIdentifier = 'secondLevelCategory';
export const firstLevelCategoryIdentifier = 'firstLevelCategory';
export const flatLevelCategoryIdentifier = 'flatLevelCategory';
